import { Authenticated } from "@refinedev/core";
import { Navigate } from "react-router-dom";

import { Layout } from "./layout/Layout";

export function ProtectedRoute(): JSX.Element {
  return (
    <Authenticated key="protected" fallback={<Navigate to="/login" replace />}>
      <Layout />
    </Authenticated>
  );
}
